import React from 'react';
import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import navLogo from 'assets/images/lottoReco-white-logo.png';

export const LOGO_URL = navLogo;

const styles = StyleSheet.create({
  headerRow: {
    backgroundColor: '#2C6CA0',
    minHeight: 45,
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 16,
    paddingRight: 16,
    flexDirection: 'row',
    alignItems: 'center',
  },
  leftCol: {
    width: '35%',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  centerCol: {
    width: '33%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  rightCol: {
    width: '32%',
    alignItems: 'flex-end',
    justifyContent: 'center',
  },
  logo: {
    width: 123,
    height: 24,
  },
  storeName: {
    margin: 0,
    fontSize: 20,
    fontWeight: 700,
    color: '#ffffff',
    lineHeight: 1,
  },
  address: {
    marginTop: 2,
    fontSize: 13,
    fontStyle: 'italic',
    color: '#ffffff',
    lineHeight: 1,
  },
  reportDate: {
    margin: 0,
    fontSize: 18,
    fontWeight: 700,
    color: '#ffffff',
    lineHeight: 1,
  },
});

interface PdfCommonHeaderProps {
  storeName: string;
  address: string;
  reportDate: string;
}

const PdfCommonHeader: React.FC<PdfCommonHeaderProps> = ({ storeName, address, reportDate }) => (
  <View style={styles.headerRow}>
    <View style={styles.leftCol}>
      <Image src={LOGO_URL} style={styles.logo} />
    </View>
    <View style={styles.centerCol}>
      <Text style={styles.storeName}>{storeName}</Text>
      <Text style={styles.address}>{address}</Text>
    </View>
    <View style={styles.rightCol}>
      <Text style={styles.reportDate}>{reportDate}</Text>
    </View>
  </View>
);

export default PdfCommonHeader;
